import { Observable } from "rxjs";
import { FiltroInformeNhCenso } from "../entity/filtro-informe-nh-censo.model";
import { TipoInformeNh } from "../entity/tipo-informe.model";

export abstract class InformesNhGateway {

    abstract consultarInformesNh(codigoTipo: number): Observable<TipoInformeNh[]>;
    abstract consultarInformeNhCenso(filtros: FiltroInformeNhCenso): Observable<any>;
    abstract consultarInformeNhRespaldoProgramacion(filtros: FiltroInformeNhCenso): Observable<any>;


}